module.exports = __webpack_public_path__ + "static/media/post03.6701fe64.jpg";